import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import Select from "react-select";
import InputGroup from "react-bootstrap/InputGroup";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import Loading from "../../common/Loading";
import imageX from "../../assets/images/x.svg";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css"; // Import styles
import "react-calendar/dist/Calendar.css"; // Required for calendar display
import { customStyles, customStylesError } from "../../common/CustomStyles";

const AddSubscription = (props) => {
  let history = useHistory();
  const myRef = useRef(null);
  let { uuid, userUUID } = useParams();
  const [dateValEnd, setDateValEnd] = useState(); // Default end date
  const [mounted, setMounted] = useState(false); // Default selected date
  const [familyDetails, setFamilyDetails] = useState([]);
  const [userCreateUpdate, setUserCreateUpdate] = useState();
  const [userCreateUpdateFor, setUserCreateUpdateFor] = useState();
  const [subscriptionsUrl, setSubscriptionsUrl] = useState("");
  const [backText, setBackText] = useState("Back to My Outgoings");
  const [successToast, setSuccessToast] = useState(false);
  const [addUpdate, setaddUpdate] = useState(false);
  const [Loadingdata, setLoadingdata] = useState(true);
  const [otherModal, setOtherModal] = useState(false);
  const [otherType, setOtherType] = useState("");
  const [familyUserId, setFamilyUserId] = useState();

  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const initialValues = {
    product_name: "",
    supplier: "",
    category: "",
    subcategories: "",
    otherCategory: "",
    otherSubCategory: "",
    otherSupplierName: "",
    additional_details: "",
    amount: "",
    frequency: "",
    start_date: null,
    end_date: null,
    contract_doc: "",
    uploaded_doc: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubCat, setSelectedSubCat] = useState();
  const [selectedSupplier, setSelectedSupplier] = useState();
  const [selectedFreq, setSelectedFreq] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [browserMsg, setBrowserMsg] = useState("");
  const [browserErrMsg, setBrowserErrMsg] = useState("");
  const [uploadedDocUrl, setUploadedDocUrl] = useState("");
  const [fileLoader, setFileLoader] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [autoRenewal, setautoRenewal] = useState(true);
  const [otherCat, setOtherCat] = useState("");
  const [otherSubCat, setOtherSubCat] = useState("");
  const [otherSupplier, setOtherSupplier] = useState("");

  const onSwitchAction = () => {
    setIsSwitchOn(!isSwitchOn);
  };
  const RenewalFunction = () => {
    setautoRenewal(!autoRenewal);
  };

  const [CategoryData, setCategoryData] = useState([]);
  const [alldata, setAlldata] = useState();

  const initialCategoryOption = [{ label: "Select a category", value: "" }];
  const [CategoryOption, setCategoryOption] = useState(initialCategoryOption); // category option

  const initialSubCatOption = [{ label: "Select a subcategory", value: "" }];
  const [subcatOption, setSubcatOption] = useState(initialSubCatOption); // subcategory option

  const initialSupplierOption = [{ label: "Select a supplier", value: "" }];
  const [supplierOption, setSupplierOption] = useState(initialSupplierOption); // supplier option
  const initialFrequencyOption = [
    { value: "Monthly", label: "Monthly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Bi-Annually", label: "Bi Annually" },
    { value: "Yearly", label: "Yearly" },
  ];
  const [frequencyOption, setFrequencyOption] = useState(
    initialFrequencyOption
  );

  const handleChange = (e, action) => {
    let targetData;
    // Handle action (e.g., for supplier selection)
    if (action) {
      targetData = {
        name: action.name,
        value: e.value,
      };
      if (action.name === "category") {
        if (e.label === "Others") {
          setOtherType("Category");
          setOtherModal(true); // Open the modal
        }
        setSelectedCategory(e);
        // find the supplier related to category
        const result = CategoryData.find((product) => product.id === e.value);

        const supData = result.subcategories.map((val) => ({
          value: val.id,
          label: val.name,
        }));
        const updatedArr = [
          ...supData,
          {
            value: alldata.otherCatndSuppliersData[0].subcategory_id,
            label: alldata.otherCatndSuppliersData[0].subcategory_name,
          },
        ];
        const sortedData =
          e.label === "Others"
            ? [...supData].sort((a, b) => a.label.localeCompare(b.label))
            : [...updatedArr].sort((a, b) => a.label.localeCompare(b.label)); // sort subcat array based on a-z
        setSubcatOption(sortedData);
        setOtherSubCat("");
        setOtherSupplier("");
        setSelectedSubCat(initialSubCatOption);
        setSupplierOption();
        setSelectedSupplier(initialSupplierOption);
        setFormValues((prevValues) => ({
          ...prevValues,
          supplier: "",
          subcategories: "",
        }));
      }

      if (action.name === "subcategories") {
        if (e.label === "Others") {
          setOtherType("Subcategory");
          setOtherModal(true); // Open the modal
        }

        setSelectedSubCat(e);

        const result = CategoryData.find((product) =>
          product.subcategories.find((val) => val.id === e.value)
        );

        const result1 = result.subcategories.find((val) => val.id === e.value);

        const supData = result1.suppliers.map((val) => ({
          value: val.id,
          label: val.name,
        }));
        const updatedArr = [
          ...supData,
          {
            value: alldata.otherCatndSuppliersData[0].supplier_id,
            label: alldata.otherCatndSuppliersData[0].subcategory_name,
          },
        ];

        const sortedData =
          e.label === "Others"
            ? [...supData].sort((a, b) => a.label.localeCompare(b.label))
            : [...updatedArr].sort((a, b) => a.label.localeCompare(b.label)); // sort supplier array based on a-z
        setSupplierOption(sortedData);
        setSelectedSupplier(initialSupplierOption);
        setOtherSupplier("");
        setFormValues((prevValues) => ({
          ...prevValues,
          supplier: "",
        }));
      }

      if (action.name === "supplier") {
        if (e.label === "Others") {
          setOtherType("Supplier");
          setOtherModal(true); // Open the modal
        }
        setSelectedSupplier(e); // Set selected supplier
        setFormErrors((prevErrors) => ({ ...prevErrors, supplier: "" })); // Clear form errors
      }

      if (action.name === "frequency") {
        setSelectedFreq(e);
        setFormErrors((prevErrors) => ({ ...prevErrors, frequency: "" }));
      }
    }
    // Handle `amount` input
    else if (e.target.name === "amount") {
      const inputValue = e.target.value;

      // Allow only up to 2 decimal places
      const formattedValue = inputValue.includes(".")
        ? inputValue.split(".")[0] + "." + inputValue.split(".")[1].slice(0, 2)
        : inputValue;

      // Prevent negative values
      if (parseFloat(formattedValue) >= 0 || formattedValue === "") {
        targetData = {
          name: e.target.name,
          value: formattedValue,
        };
      }
    }
    // General case
    else {
      targetData = {
        name: e.target.name,
        value: e.target.value,
      };
    }

    const { name, value } = targetData;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));

    // Handle specific fields
    switch (name) {
      case "uploaded_doc":
        handleFileUpload(e.target.files[0]);
        break;

      case "frequency":
        setFormErrors((prevErrors) => ({ ...prevErrors, frequency: "" }));
        break;

      case "amount":
        setFormErrors((prevErrors) => ({ ...prevErrors, amount: "" }));
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (mounted) {
      if (dateValEnd) {
        setFormValues((prevValues) => ({
          ...prevValues,
          end_date: dateValEnd,
        }));
        setFormErrors((prevErrors) => ({ ...prevErrors, end_date: "" }));
      }
    }
  }, [dateValEnd]);
  console.log(formValues.end_date);
  // Reset dropdown when modal closes
  const handleCloseModal = () => {
    setOtherModal(false); // Close the modal
    setSelectedSupplier(initialSupplierOption); // Reset the selected supplier

    if (otherType === "Category") {
      setSelectedCategory(initialCategoryOption);
      setSelectedSubCat(initialSubCatOption);
      setSubcatOption(initialSubCatOption);
      setSupplierOption(initialSupplierOption);

      setFormValues((prevValues) => ({
        ...prevValues,
        category: "",
        otherCategory: "",
      }));
    } else if (otherType === "Subcategory") {
      setSelectedSubCat(initialSubCatOption);
      setSupplierOption(initialSupplierOption);
      setFormValues((prevValues) => ({
        ...prevValues,
        subcategories: "",
        otherSubCategory: "",
      }));
    } else {
      setFormValues((prevValues) => ({
        ...prevValues,
        supplier: "",
        otherSupplierName: "",
      }));
    }
    setOtherSupErr("");
  };

  const [otherSupErr, setOtherSupErr] = useState("");

  const submitModal = () => {
    // Check if the input field is empty
    if (
      !formValues.otherSupplierName &&
      !formValues.otherCategory &&
      !formValues.otherSubCategory
    ) {
      setOtherSupErr("otherSupErr");
      return; // Do not proceed if the input field is empty
    }
    setOtherSupErr("");
    setOtherCat(formValues.otherCategory);
    setOtherSubCat(formValues.otherSubCategory);
    setOtherSupplier(formValues.otherSupplierName);
    setSelectedSupplier(initialSupplierOption); // Reset the selected supplier
    setTimeout(() => {
      setOtherModal(false); // Close the modal
    }, 100);
  };

  const [newStartDate, setNewStartDate] = useState();
  useEffect(() => {
    if (formValues.end_date && formValues.frequency) {
      const endDateValue = new Date(formValues.end_date); // Create a Date object
      let monthsToSubtract = 0;

      // Determine the number of months to subtract based on frequency
      switch (formValues.frequency) {
        case "Monthly":
          monthsToSubtract = 1;
          break;
        case "Quarterly":
          monthsToSubtract = 3;
          break;
        case "Bi-Annually":
          monthsToSubtract = 6;
          break;
        case "Yearly":
          monthsToSubtract = 12;
          break;
        default:
          monthsToSubtract = 0;
      }

      // Create a new date without mutating endDateValue
      const newStartDate = new Date(endDateValue);
      newStartDate.setMonth(newStartDate.getMonth() - monthsToSubtract);
      setNewStartDate(newStartDate);
    }
  }, [formValues.end_date, formValues.frequency]); // Dependency array

  // Helper Functions
  const handleFileUpload = (documentFile) => {
    if (!documentFile) {
      setFileLoader(false);
      return;
    }

    const MAX_FILE_SIZE = 2; // 2MB
    const allowedFileTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/msword", // .doc
    ];

    const fileReader = new FileReader();
    setFileLoader(true);
    fileReader.onload = () => {
      if (allowedFileTypes.includes(documentFile.type)) {
        const fileSize = documentFile.size / 1024 / 1024; // Convert to MB
        if (fileSize > MAX_FILE_SIZE) {
          setBrowserErrMsg("OOPS! File size is above 2MB.");
          setFileLoader(false);
        } else {
          uploadFile(documentFile);
        }
      } else {
        setBrowserErrMsg("OOPS! The file format doesn't support.");
        setFileLoader(false);
      }
    };

    fileReader.readAsDataURL(documentFile);
  };

  // State to manage uploaded files
  const [uploadedDocArray, setUploadedDocArray] = useState([]);
  // file upload
  const uploadFile = (data) => {
    setBrowserErrMsg("");
    const formData = new FormData();
    formData.append("file", data, data.name.replace(/ /g, ""));
    UserService.uploadUserDocuments(formData).then(
      (response) => {
        setBrowserMsg("Successfully uploaded");
        setUploadedDocUrl(response.link);
        setUploadedDocArray((prevArray) => [...prevArray, response.link[0]]); // Push to the array
        setaddUpdate(false);
        setFileLoader(false);
      },
      (error) => {
        setBrowserErrMsg("Something went error");
        setaddUpdate(false);
      }
    );
  };

  // Function to delete a file
  const deleteFile = (fileUrl) => {
    setUploadedDocArray((prevFiles) =>
      prevFiles.filter((file) => file !== fileUrl)
    );
  };

  // end
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form and get the errors immediately
    const errors = validate(formValues);

    // Update the form errors state
    setFormErrors(errors);

    // Set other states
    setIsSubmit(true);
    setLoading(true);

    // Log errors immediately after validation

    // Call your submit handler
    submitBtn(Object.keys(errors).length);
  };
  const validate = (values) => {
    const errors = {};
    // if (!values.product_name) {
    //   errors.msg = "Please enter the product name";
    //   errors.product_name = "Yes";
    // }
    if (!values.category) {
      errors.msg = "Please select the category";
      errors.category = "Yes";
    }
    if (!values.subcategories) {
      errors.msg = "Please select the subcategories";
      errors.subcategories = "Yes";
    }
    if (!values.amount || values.amount === 0 || values.amount < 0) {
      errors.msg = "Please enter the amount";
      errors.amount = "Yes";
    }
    if (!values.supplier) {
      errors.msg = "Please select the supplier";
      errors.supplier = "Yes";
    }
    if (!values.frequency) {
      errors.msg = "Please enter the frequency";
      errors.frequency = "Yes";
    }
    // if (!values.start_date) {
    //   errors.msg = "Please enter the start date";
    //   errors.start_date = "Yes";
    // }
    if (!values.end_date) {
      errors.msg = "Please enter the end date";
      errors.end_date = "Yes";
    }
    return errors;
  };

  useEffect(() => {
    if (isSubmit) {
      const errors = validate(formValues);
      setFormErrors(errors);
    }
  }, [formValues, isSubmit]);

  const getFamilyDetails = (userId) => {
    // AU Family details
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        setFamilyDetails(response);
        setUserCreateUpdateFor(response.FamilyData.id);

        // SU Family details
        UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
          (response) => {
            setUserCreateUpdate(response.FamilyData.UserId);
          },
          (error) => {}
        );
      },
      (error) => {}
    );
  };

  const getAUFamilyDetails = (userId) => {
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        setFamilyDetails(response);
        setUserCreateUpdate(response.FamilyData.UserId);
        setUserCreateUpdateFor(response.FamilyData.id);
      },
      (error) => {}
    );
  };

  const [timeZone, setTimeZone] = useState(0);

  useEffect(() => {
    const offsetInMinutes = new Date().getTimezoneOffset();
    setTimeZone(offsetInMinutes);
    UserService.relationData(uuid).then((response) => {
      // main user checking
      const mainUser = response.data.au.find(
        (obj) => obj.User.email === UserDetails.email
      );

      const mainArr = [];
      if (mainUser) {
        mainArr.push(mainUser);
      }

      // support user checking
      const suppUser = response.data.au.find((obj) =>
        obj.su.find(
          (family) =>
            family.Family_User &&
            family.Family_User.User.email === UserDetails.email
        )
      );

      const suppArr = [];
      if (suppUser) {
        suppArr.push(suppUser);
      }

      let newArray = [];
      newArray = [...mainArr, ...suppArr];

      const uuidFind = newArray.find((obj) => obj.User.uuid === userUUID);

      userUUID && setFamilyUserId(uuidFind.id);
    });

    // get family details
    if (userUUID) {
      UserService.userProfile(userUUID).then((response) => {
        getFamilyDetails(response.userData.id);
        setSubscriptionsUrl("/user_myoutgoings/" + uuid + "/" + userUUID);
        setBackText(
          response.userData.firstName === "null"
            ? response.userData.email
            : response.userData.firstName + " " + response.userData.lastName ===
              "null"
            ? ""
            : response.userData.lastName
        );
      });
    } else {
      getAUFamilyDetails(UserDetails.id);
      setSubscriptionsUrl("/myoutgoings/" + uuid);
    }

    // get supplier data
    UserService.getCatbyMod(1).then((resp) => {
      setAlldata(resp.data);
      setCategoryData(resp.data.data);
      const selectedData = resp.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      const sortedData = [...selectedData].sort((a, b) =>
        a.label.localeCompare(b.label)
      ); // sort cat array based on a-z
      setCategoryOption(sortedData);
      setTimeout(() => {
        setLoadingdata(false);
        setMounted(true);
      }, 250);
    });
  }, []);

  function keepSameDateTimeInUTC(dateString) {
    let date = new Date(dateString); // Create Date object
    date.setMinutes(date.getMinutes() - timeZone); // 5 hours 30 minutes = 330 minutes
    return date;
  }

  const submitBtn = (length) => {
    // add subscription
    if (length === 0 && formValues.amount > 0) {
      setLoading(true);
      // Convert to string
      // Convert array to a single string (comma-separated)
      const urlsAsString =
        uploadedDocArray.length > 0 ? JSON.stringify(uploadedDocArray) : "";

      // convert current time in timestamp
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      let data = {
        category: formValues.category,
        subCategory: formValues.subcategories,
        supplier: formValues.supplier,
        productName: `${familyDetails.FamilyData.FamilyId}_${
          userUUID ? familyUserId : familyDetails.FamilyData.id
        }_${year}${month}${day}${hours}${minutes}${seconds}`,
        otherSupplierName: formValues.otherSupplierName,
        otherCategory: formValues.otherCategory,
        otherSubCategory: formValues.otherSubCategory,
        premiumAmount: formValues.amount,
        renewalFrequency: formValues.frequency,
        startDate: keepSameDateTimeInUTC(newStartDate),
        endDate: keepSameDateTimeInUTC(formValues.end_date),
        documentUrl: urlsAsString,
        productDescription: formValues.additional_details,
        country: 1,
        currency: 1,
        reminder: isSwitchOn ? 1 : 0,
        autoRenewal: autoRenewal,
        updatedBy: userCreateUpdate,
        createdUpdatedFor: userUUID
          ? familyUserId
          : familyDetails.FamilyData.id,
        familyId: familyDetails.FamilyData.FamilyId,
        FamilyUserId: userUUID ? familyUserId : familyDetails.FamilyData.id,
        createdBy: userCreateUpdate,
      };
      console.log(data);
      // // api call
      UserService.createSubscritpion(data).then(
        (response) => {
          if (response.status === 200 || response.status === 201) {
            setLoading(false);
            setSuccessToast(true);
            setShowToast(true);
            // executeScroll();
            window.scrollTo(0, 0);
            setToastMessage("Outgoing created successfully");
            setTimeout(() => {
              history.push(subscriptionsUrl);
            }, 2000);
          } else {
            setLoading(false);
            setSuccessToast(false);
            setShowToast(true);
            window.scrollTo(0, 0);
            setToastMessage("Error !");
          }
        },
        (error) => {}
      );
    } else {
      setLoading(false);
      // window.scrollTo(0, 0);
    }
  };

  return (
    <Container ref={myRef}>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      {Loadingdata ? (
        <>
          <div className="d-flex" style={{ minHeight: "calc(100vh - 17rem)" }}>
            <Loading />
          </div>
        </>
      ) : (
        <Row className="justify-content-center gy-0 mb-6rem new-datepicker">
          <Col xl="21" xxl="18">
            <h1 className="lh-base mb-4">Add a new outgoing</h1>
            <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
              <Form onSubmit={handleSubmit} encType="multipart/form-data">
                <section>
                  <h2 className="mb-1 mb-md-2">Details</h2>
                  <p className="mb-4">
                    Add your outgoings – from subscriptions to recurring
                    payments for products and services. To make it easier, all
                    selections are from dropdown menus. If you're ever unsure or
                    can't find your selection at any stage, simply choose
                    'Others' to enter your own option.
                  </p>

                  <Row className="gy-0 mb-4">
                    {
                      <Col md="12" lg="12">
                        <Form.Label
                          className={formErrors.category ? "text-danger" : " "}
                        >
                          Outgoings Category
                        </Form.Label>
                        {otherCat ? (
                          <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                            {otherCat}{" "}
                            <button
                              className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                              type="button"
                              onClick={() => {
                                setOtherCat("");
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  otherCategory: "",
                                  category: "",
                                }));
                              }}
                            >
                              <img
                                src={imageX}
                                alt=""
                                style={{ width: "16px", height: "16px" }}
                              />
                            </button>
                          </div>
                        ) : (
                          <Select
                            styles={
                              formErrors.category
                                ? customStylesError
                                : customStyles
                            }
                            options={CategoryOption}
                            defaultValue={{
                              label: "Select a category",
                              value: "",
                            }}
                            value={selectedCategory}
                            onChange={handleChange}
                            name="category"
                          />
                        )}
                        <Form.Text
                          className={formErrors.category ? "text-danger" : " "}
                        >
                          Select the correct category for this outgoing to see
                          relevant sub-categories and suppliers
                        </Form.Text>
                      </Col>
                    }
                  </Row>
                  <Row className="gy-0 mb-4">
                    {
                      <Col md="12" lg="12">
                        <Form.Label
                          className={
                            formErrors.subcategories ? "text-danger" : " "
                          }
                        >
                          Outgoings Subcategory
                        </Form.Label>

                        {otherSubCat ? (
                          <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                            {otherSubCat}{" "}
                            <button
                              className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                              type="button"
                              onClick={() => {
                                setOtherSubCat("");
                                setSelectedSubCat(initialSubCatOption);
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  otherSubCategory: "",
                                  subcategories: "",
                                }));
                              }}
                            >
                              <img
                                src={imageX}
                                alt=""
                                style={{ width: "16px", height: "16px" }}
                              />
                            </button>
                          </div>
                        ) : (
                          <Select
                            styles={
                              formErrors.subcategories
                                ? customStylesError
                                : customStyles
                            }
                            options={subcatOption}
                            defaultValue={{
                              label: "Select a subcategory",
                              value: "",
                            }}
                            value={selectedSubCat}
                            onChange={handleChange}
                            name="subcategories"
                          />
                        )}
                        <Form.Text
                          className={
                            formErrors.subcategories ? "text-danger" : " "
                          }
                        >
                          Now, select the specific type for this outgoing. For
                          example, if you selected 'Insurance,' you might choose
                          'Car', 'Van', or 'Home' insurance.
                        </Form.Text>
                      </Col>
                    }
                  </Row>
                  <Row className="gy-0 mb-4">
                    {
                      <Col md="12" lg="12">
                        <Form.Label
                          className={formErrors.supplier ? "text-danger" : " "}
                        >
                          Outgoings Supplier
                        </Form.Label>
                        {otherSupplier ? (
                          <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                            {otherSupplier}{" "}
                            <button
                              className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                              type="button"
                              onClick={() => {
                                setOtherSupplier("");
                                setFormValues((prevValues) => ({
                                  ...prevValues,
                                  otherSupplierName: "",
                                }));
                              }}
                            >
                              <img
                                src={imageX}
                                alt=""
                                style={{ width: "16px", height: "16px" }}
                              />
                            </button>
                          </div>
                        ) : (
                          <Select
                            styles={
                              formErrors.supplier
                                ? customStylesError
                                : customStyles
                            }
                            options={supplierOption}
                            defaultValue={{
                              label: "Select a supplier",
                              value: "",
                            }}
                            value={selectedSupplier}
                            onChange={handleChange}
                            name="supplier"
                          />
                        )}
                        <Form.Text
                          className={formErrors.supplier ? "text-danger" : " "}
                        >
                          Select the company or provider for this outgoing. If
                          you can’t find your supplier, simply choose 'Other' to
                          enter it manually
                        </Form.Text>
                      </Col>
                    }
                  </Row>

                  {/* <Row className="gy-0 mb-4">
                    <Col md="12" lg="12">
                      <Form.Label
                        className={
                          formErrors.product_name ? "text-danger" : " "
                        }
                      >
                        Name your Outgoing
                      </Form.Label>
                      <Form.Control
                        className={formErrors.product_name ? "is-invalid" : ""}
                        type="text"
                        placeholder="e.g. Car insurance"
                        name="product_name"
                        maxLength={255}
                        value={formValues.product_name}
                        onChange={handleChange}
                      />
                      <Form.Text
                        className={
                          formErrors.product_name ? "text-danger" : " "
                        }
                      >
                        Please enter the product name
                      </Form.Text>
                    </Col>
                  </Row> */}
                  <Row className="gy-0">
                    <Col xs="24">
                      <Form.Label>
                        Comments
                        <span className="small text-muted fw-normal ms-1">
                          Optional
                        </span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        cols={5}
                        name="additional_details"
                        placeholder="Add any extra details or special notes here​"
                        value={formValues.additional_details}
                        onChange={handleChange}
                        maxLength={255}
                      />
                      <Form.Text>
                        Provide any extra information or specific notes about
                        the outgoing.
                      </Form.Text>
                    </Col>
                  </Row>
                </section>
                <hr className="my-6 my-md-7" />
                <section>
                  <h3 className="mb-1 mb-md-2">Payment</h3>
                  <p className="mb-4">
                    Set up your payment plan – let’s capture how much and how
                    often you pay for these products or services​
                  </p>
                  <Row className="gy-0 mb-4">
                    <Col xs="18" sm="14" md="12" lg="8">
                      <Form.Label
                        className={formErrors.amount ? "invalid-text" : ""}
                      >
                        Amount
                      </Form.Label>
                      <InputGroup
                        className={formErrors.amount ? "is-invalid" : ""}
                      >
                        <InputGroup.Text>
                          <i className="fa-solid fa-pound-sign fa-sm"></i>
                        </InputGroup.Text>
                        <Form.Control
                          className={
                            formErrors.amount
                              ? "is-invalid invalid-border-right"
                              : ""
                          }
                          type="number"
                          onWheel={() => document.activeElement.blur()}
                          name="amount"
                          value={formValues.amount < 0 ? "" : formValues.amount}
                          onBlur={() => {
                            if (formValues.amount && formValues.amount > 0) {
                              const formattedValue = parseFloat(
                                formValues.amount
                              ).toFixed(2); // Format to 2 decimal places
                              setFormValues((prevValues) => ({
                                ...prevValues,
                                amount: formattedValue, // Update the price with the formatted value
                              }));
                            }
                          }}
                          onChange={handleChange}
                        />
                      </InputGroup>
                      <Form.Text
                        className={formErrors.amount ? "text-danger" : " "}
                      >
                        Please enter the amount
                      </Form.Text>
                    </Col>
                  </Row>
                  <Row className="gy-0 mb-4">
                    <Col xs="18" sm="14" md="12" lg="8">
                      <Form.Label
                        className={formErrors.frequency ? "invalid-text" : ""}
                      >
                        Billing term
                      </Form.Label>
                      <Select
                        styles={
                          formErrors.frequency
                            ? customStylesError
                            : customStyles
                        }
                        options={frequencyOption}
                        defaultValue={{
                          label: "Select a billing frequency",
                          value: "",
                        }}
                        value={selectedFreq}
                        onChange={handleChange}
                        name="frequency"
                      />
                      <Form.Text
                        className={formErrors.frequency ? "text-danger" : " "}
                      >
                        Please select the billing term
                      </Form.Text>
                    </Col>
                  </Row>
                  <Row className="gy-0">
                    <Col md="auto" className="mb-3">
                      <Form.Label className="mb-0">Auto Renewal</Form.Label>
                      <Form.Switch
                        onChange={RenewalFunction}
                        id="custom-switch-renewal"
                        checked={autoRenewal}
                      />
                    </Col>
                  </Row>
                  <Row className="gy-4 gx-md-4 gy-md-0 mb-4">
                    {/* <Col xs="18" sm="14" md="12" lg="8">
                      <Form.Label
                        className={formErrors.start_date ? "invalid-text" : ""}
                      >
                        Start date
                      </Form.Label>
                      <InputGroup
                        className={formErrors.start_date ? "is-invalid" : ""}
                      >
                        <DatePicker
                          onChange={setDateValStart}
                          name="start_date"
                          value={dateValStart ? new Date(dateValStart) : null} // Ensure Date object
                          format="dd-MM-yyyy" // Format for display
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yyyy"
                          clearIcon={null} // Hide clear button
                          className={`${
                            formErrors.start_date
                              ? "is-invalid invalid-border-right"
                              : ""
                          } form-control`}
                          // view="month" // Month selection
                          // maxDetail="year" // Show Year > Month > Date
                        />
                      </InputGroup>
                      <Form.Text
                        className={formErrors.start_date ? "text-danger" : " "}
                      >
                        Please select the start date
                      </Form.Text>
                    </Col> */}
                    <Col xs="18" sm="14" md="12" lg="8">
                      <Form.Label
                        className={formErrors.end_date ? "text-danger" : " "}
                      >
                        Next renewal on
                      </Form.Label>
                      <InputGroup
                        className={formErrors.end_date ? "is-invalid " : ""}
                      >
                        <DatePicker
                          onChange={setDateValEnd}
                          name="end_date"
                          value={dateValEnd ? new Date(dateValEnd) : null}
                          format="dd-MM-yyyy" // Format for display
                          dayPlaceholder="dd"
                          monthPlaceholder="mm"
                          yearPlaceholder="yyyy"
                          minDate={new Date()} // Prevent past dates
                          clearIcon={null} // Hide clear button
                          className={`${
                            formErrors.end_date
                              ? "is-invalid invalid-border-right"
                              : ""
                          } form-control`}
                        />
                      </InputGroup>
                      <Form.Text
                        className={formErrors.end_date ? "text-danger" : " "}
                      >
                        Please select the next renewal date
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="gy-0">
                    <Col md="auto">
                      <Form.Label className="mb-0">Reminder</Form.Label>
                      <p className="mb-2">
                        Standard reminder settings will be applied to this
                        outgoing.
                      </p>
                      <Form.Switch
                        onChange={onSwitchAction}
                        id="custom-switch"
                        checked={isSwitchOn}
                      />
                    </Col>
                  </Row>
                </section>
                <hr className="my-6 my-md-7" />
                <section class="mb-4">
                  <h3 className="mb-1 mb-md-2">
                    Upload attachment
                    <span className="small text-muted fw-normal ff-body ms-2">
                      Optional
                    </span>
                  </h3>
                  <p className="mb-4">
                    Upload any important documents related to your outgoings –
                    this could be contracts, receipts, or payment
                    confirmations.​
                  </p>
                  <Row className="gy-0">
                    <Col xl="21" xxl="24" className="mb-3">
                      <Form.Control
                        className="d-none"
                        type="file"
                        id="upload"
                        name="uploaded_doc"
                        onClick={(e) => {
                          e.target.value = null;
                        }}
                        onChange={handleChange}
                        accept="image/png, image/jpg, image/jpeg, application/pdf,  application/vnd.openxmlformats-officedocument.wordprocessingml.document,  application/msword"
                      />
                      {fileLoader ? (
                        <div
                          className=" btn-upload mb-0 form-label"
                          style={{ cursor: "auto" }}
                        >
                          <Loading />
                        </div>
                      ) : (
                        <Form.Label
                          className="btn btn-upload mb-0"
                          for="upload"
                        >
                          <i className="fa-solid fa-upload fa-2xl lh-1"></i>
                          <div className="h6 lh-base mt-4 mb-1">
                            Upload an attachment
                          </div>
                          <p className="small fw-normal text-muted mb-0">
                            We accept PNG, JPG, JPEG, PDF & DOC. (Maximum file
                            size 2MB)
                          </p>
                          <p className="mt-3 text-danger">{browserErrMsg}</p>
                        </Form.Label>
                      )}
                      {/* {fileLoader ? (
                        <div
                          className=" btn-upload mb-0 form-label"
                          style={{ cursor: "auto" }}
                        >
                          <Loading />
                        </div>
                      ) : uploadedDocUrl ? (
                        <div className="btn btn-upload mb-0 form-label justify-content-center d-flex align-items-center gap-2 m-auto">
                          <div>{showInvoiceFile}</div>
                          <button
                            className="btn btn-danger py-1 px-2"
                            onClick={removeUploadedFile} // This function will handle image removal
                          >
                            <i className="fa-solid fa-trash text-white"></i>
                          </button>
                        </div>
                      ) : (
                        <Form.Label
                          className="btn btn-upload mb-0"
                          for="upload"
                        >
                          <i className="fa-solid fa-upload fa-2xl lh-1"></i>
                          <div className="h6 lh-base mt-4 mb-1">
                            Upload an attachment
                          </div>
                          <p className="small fw-normal text-muted mb-0">
                            We accept PNG, JPG, JPEG, PDF & DOC. (Maximum file
                            size 2MB)
                          </p>
                          <p className="mt-3 text-danger">{browserErrMsg}</p>
                        </Form.Label>
                      )} */}
                    </Col>

                    {/* uploaded files  */}
                    {uploadedDocArray && uploadedDocArray.length > 0 && (
                      <Col xl="21" xxl="24">
                        <div className="fs-18 bold-colour mb-2 fw-medium">
                          Files selected for upload
                        </div>
                        <div>
                          {uploadedDocArray.map((file, index) => (
                            <div
                              key={index}
                              className="file-item p-3 mb-3 d-flex align-items-center justify-content-between"
                              style={{
                                boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px",
                                borderRadius: "12px",
                              }}
                            >
                              <div>{file.split("/").pop()}</div>
                              <button
                                className="btn btn-danger py-1 px-2"
                                onClick={() => deleteFile(file)} // This function will handle image removal
                              >
                                <i className="fa-solid fa-trash text-white"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      </Col>
                    )}
                  </Row>
                </section>
                <div className="d-flex justify-content-end">
                  <Button
                    className="d-flex align-items-center"
                    variant="primary"
                    type="submit"
                    isLoading={loading ? "true" : "false"}
                    isDisabled={loading ? "true" : "false"}
                  >
                    <i className="fa-solid fa-sm fa-add lh-1 align-middle me-2"></i>
                    Add outgoing
                  </Button>
                </div>
              </Form>
            </section>
          </Col>
        </Row>
      )}

      {/* uploaded document   */}
      <Modal show={otherModal} onHide={() => handleCloseModal()} className="">
        <Modal.Header closeButton>
          <Modal.Title className="mx-1">
            <h3 className="mb-0">
              Add other {otherType.charAt(0).toLowerCase() + otherType.slice(1)}{" "}
              name
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-5">
            <Form.Label className={otherSupErr ? "text-danger" : ""}>
              {otherType} name
            </Form.Label>
            <Form.Control
              className={`mb-2 ${
                otherSupErr ? "is-invalid invalid-border-right" : ""
              }`}
              type="text"
              maxlength="100"
              placeholder="e.g. Starbucks"
              name={
                otherType === "Category"
                  ? "otherCategory"
                  : otherType === "Subcategory"
                  ? "otherSubCategory"
                  : "otherSupplierName"
              }
              value={
                otherType === "Category"
                  ? formValues.otherCategory
                  : otherType === "Subcategory"
                  ? formValues.otherSubCategory
                  : formValues.otherSupplierName
              }
              onChange={handleChange}
            />
            <Form.Text className={otherSupErr ? "text-danger mb-4" : "mb-4"}>
              Please enter the name of the{" "}
              {otherType.charAt(0).toLowerCase() + otherType.slice(1)} if you
              haven't found their name in the dropdown
            </Form.Text>
          </div>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => submitModal()}
          >
            + Add
          </button>
        </Modal.Body>
      </Modal>
    </Container>
  );
};
export default AddSubscription;
